import { createReducer } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import appReducer from "./appReducer";
import type { CanvasWidgetsReduxState } from "./canvasWidgetsReducer";
import embedMetaReducer from "./embedMetaReducer";
import metaReducer from "./metaReducer";
import pageListReducer from "./pageListReducer";

const entityReducer = combineReducers({
  canvasWidgets: createReducer({} as CanvasWidgetsReduxState, () => {}),
  pageList: pageListReducer,
  meta: metaReducer,
  embedPropsMeta: embedMetaReducer,
  app: appReducer,
});

export type EntitiesState = ReturnType<typeof entityReducer>;

export default entityReducer;
